import React from 'react';
import { motion } from 'framer-motion';
import { FiFolder } from 'react-icons/fi';

const projects = [
  {
    title: 'Workflow Automation Agents',
    description: 'Developed AI Agents capable of connecting with multiple 3rd party integrations. They understand user intent, execute automated workflows, and manage tasks across email, calendar, and business apps.',
    tech: ['LangChain', 'RAG', 'Node.js', 'APIs']
  },
  {
    title: 'SaaS Subscription System',
    description: 'Led the Stripe subscription billing integration for a platform serving 20K+ MAU. Enabled automated recurring payments, plan upgrades/downgrades, and coupon-based pricing.',
    tech: ['Node.js', 'MongoDB', 'Stripe', 'RabbitMQ']
  },
  {
    title: 'AI Agent - GIA',
    description: 'Built a Graphical Interpretation Agent (GIA) that integrates directly with Snowflake and BigQuery. It generates AI-powered insights and charts using LLM-powered reasoning without exposing real data.',
    tech: ['Node.js', 'LLMs', 'Snowflake', 'BigQuery']
  }
];

const Projects = () => {
  return (
    <section id="projects" className="py-24 bg-slate-900/30">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Featured Engineering Feats</h2>
          <p className="text-slate-400">Showcasing my backend architecture and AI Integrations at Questera AI</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-8 rounded-2xl flex flex-col h-full group hover:-translate-y-2 transition-all duration-300"
            >
              <div className="flex justify-between items-start mb-6">
                <div className="p-3 bg-indigo-500/10 text-indigo-400 rounded-lg">
                  <FiFolder className="text-2xl" />
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-indigo-400 transition-colors">
                {project.title}
              </h3>
              
              <p className="text-slate-400 text-sm leading-relaxed mb-6 flex-grow">
                {project.description}
              </p>

              <div className="flex flex-wrap gap-2 mt-auto">
                {project.tech.map((tech) => (
                  <span key={tech} className="text-xs font-mono text-indigo-300 bg-indigo-500/10 px-2 py-1 rounded">
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;